module.exports = "/public/dist/img/how-it-works-3.jpg";